import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { PermissionsService } from '@services/helpers/permissions.service';
import { MeetingsClientHttpService } from '@services/http/meetings/meetings-client-http.service';
import { Observable, map } from 'rxjs';
import { canOpenClientMeetings } from './client-meetings-access';

/** Para onde vai quem não pode abrir as calls do cliente. */
const FALLBACK_ROUTE = '/dashboard/dashboard-management';

/**
 * Guarda das telas de calls do cliente (card 3803). Abre só com `MEETINGVISIBILITY_CLIENT_VIEW` e o
 * parâmetro "Cliente vê calls" ligado (`canOpenClientMeetings`, o mesmo sinal do item "Meetings" do
 * menu Performance). Com o parâmetro desligado, manda para a Home.
 */
export const clientMeetingsGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const router = inject(Router);
  return canOpenClientMeetings(inject(PermissionsService), inject(MeetingsClientHttpService)).pipe(
    map(allowed => (allowed ? true : router.parseUrl(FALLBACK_ROUTE)))
  );
};
